/** @format */

export function AppConfig(
    CONFIG,
    $galabidUrlProvider,
    ResourceCacheProvider,
    $urlRouterProvider,
    $locationProvider,
    $urlMatcherFactoryProvider,
    $ccPusherProvider,
    $ccRealtimeProvider,
    $gbAuthProvider,
    $httpProvider,
    $resourceProvider,
    $logProvider,
    $provide
) {
    'ngInject';

    // https://davidwalsh.name/query-string-javascript
    let urlParams = new URLSearchParams(window.location.search);
    let isEditMode = () => urlParams.get('editMode') === 'true';

    // Set API URL's
    $galabidUrlProvider.setApiDomain(CONFIG.API_DOMAIN);
    $galabidUrlProvider.setBaseApiUrl(CONFIG.BASE_API_URL);
    $galabidUrlProvider.setStaticAssetsUrl(CONFIG.STATIC_ASSETS);

    let authConfig = {};

    // Use frontend API by default
    if (isEditMode()) {
        $galabidUrlProvider.setApiUrl(CONFIG.CMS_API_URL);
        authConfig.tokenName = 'gb_presenter_token'; // Only want to use JWT in edit mode
    } else {
        $galabidUrlProvider.setApiUrl(CONFIG.APP_API_URL);
    }

    authConfig.whiteListedDomains = [$galabidUrlProvider.getApiDomain()];

    $gbAuthProvider.configure(authConfig);

    // Routing
    $urlRouterProvider.otherwise('/');
    $locationProvider.html5Mode(true);
    $urlMatcherFactoryProvider.caseInsensitive(false);
    $urlMatcherFactoryProvider.strictMode(false);

    // Pusher
    const pusherKey = process.env.PUSHER_KEY;
    $ccPusherProvider.initialise(pusherKey);
    $ccRealtimeProvider.register('$ccPusher');

    // Cache
    ResourceCacheProvider.cacheOffline = false;

    // API resources
    $resourceProvider.defaults.stripTrailingSlashes = false;

    $httpProvider.interceptors.push('jwtInterceptor');

    // Turn off logging if needed
    let PRODUCTION = CONFIG.__.toLowerCase() == 'production';

    if (PRODUCTION) {
        $logProvider.debugEnabled(false);
        $provide.decorator('$log', [
            '$delegate',
            function ($delegate) {
                $delegate.warn = angular.noop;
                $delegate.info = angular.noop;
                $delegate.error = angular.noop;
                $delegate.log = angular.noop;
                return $delegate;
            },
        ]);
    }
}
